import React from "react"

import CheckoutFlowNavButtons from "~components/pages/listing/checkout/checkout-flow/checkout-flow-nav-buttons"
import { useCheckoutFlow } from "~components/pages/listing/checkout/checkout-flow/checkout-flow-provider"
import { adjustDatesForBackend } from "~utils/quote-helpers"

import CheckoutFlowPackageSections from "./checkout-flow-package-sections"
import CheckoutFlowStep from "./checkout-flow-step"

export default function CheckoutFlowPackageStep() {
    const { dates, packageState } = useCheckoutFlow()

    const adjustedDates = adjustDatesForBackend({
        dates,
    })

    return (
        <CheckoutFlowStep
            renderNavButtons={() => (
                <CheckoutFlowNavButtons
                    isContinueDisabled={!packageState.pricing_package_id}
                />
            )}
        >
            <CheckoutFlowPackageSections dates={adjustedDates} />
        </CheckoutFlowStep>
    )
}
